import { Box } from '@mui/material';
import React from 'react';
import CustomDatePicker from './CustomDatePicker';
import GlencoreButton from './GlencoreButton';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';

interface Props {
  loading: boolean;
  onDateChange: (dates: [Date, Date]) => void;
  onFetch: () => void;
  selectedStartDate: Date;
  selectedEndDate: Date;
}

const DateRangeFilterBar = (props: Props) => {
  const { loading, onDateChange, onFetch, selectedStartDate, selectedEndDate } =
    props;

  const { theme } = useAppSelector((state) => state.authReducer.customer);
  const darkMode = isDarkTheme(theme);
  return (
    <Box
      className="w-full flex flex-wrap justify-end items-end mb-2 gap-4 pb-2 z-50 relative"
      sx={{
        backgroundColor: darkMode
          ? 'rgba(23, 42, 70, 0.5)'
          : 'rgba(255, 255, 255, 0.7)',
        borderRadius: '10px',
        padding: '16px',
        boxShadow: darkMode
          ? '0 4px 12px rgba(0,0,0,0.15)'
          : '0 2px 8px rgba(0,0,0,0.08)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Box
        className="flex justify-end items-end gap-3 z-50"
        sx={{ minWidth: '320px' }}
      >
        <CustomDatePicker
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
          onDateChange={onDateChange}
        />
        <GlencoreButton
          loading={loading}
          onClick={onFetch}
          text="Fetch Data"
          loadingText="Loading..."
        />
      </Box>
    </Box>
  );
};

export default DateRangeFilterBar;
